import { useQuery } from '@tanstack/react-query'

import { currencyServices } from '../currencyServices'
import { AboutCurrencyInBlockchainParams } from '../currencyTypes'

import { QUERY_KEYS } from '@/constants/queryKeys'

export const useGetAboutCurrencyInBlockchain = (
  params: AboutCurrencyInBlockchainParams,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.CATALOGS_CURRENCIES, params],
    queryFn: () => currencyServices.getAboutCurrencyInBlockchain(params),
    staleTime: 60 * 1000,
    enabled: !!params?.currency_isin && !!params?.blockchain_code,
  })
